export default __webpack_public_path__ + "static/media/schemeAlt.badc1a71.svg";